import { frontendURL } from '../../../helper/URLHelper';
import ChatbotsIndex from './pages/ChatbotsIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'chatbots_manage'],
  dotchatModule: 'chatbots',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/chatbots'),
    component: ChatbotsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'chatbots_index',
        component: ChatbotsIndex,
        meta: commonMeta,
      },
    ],
  },
];
